import type { ProductKeys } from '../constants/product-keys';

export const isAllProductSearch = (selectedProducts: ProductKeys[]): boolean =>
	selectedProducts.length === 0;
